(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-main"]) return;
  try {
    
(function () {
  var successHeading = document.getElementById('contact-success-heading');
  if (successHeading) {
    successHeading.focus({ preventScroll: true });
  }

  var chips = document.querySelectorAll('.c-chip');
  var hidden = document.getElementById('contact-motivo-value');
  if (!chips.length || !hidden) return;
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      hidden.value = chip.dataset.motivo || '';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
